(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
  if (!customElements.get('kd-related-products')) {
    customElements.define('kd-related-products', class extends HTMLElement {
      connectedCallback() {
        if (this.loaded) return;
        this.loaded = true;
        fetch(this.dataset.url)
          .then((response) => {
            if (!response.ok) throw new Error('Recommendations unavailable');
            return response.text();
          })
          .then((html) => {
            const section = new DOMParser().parseFromString(html, 'text/html').querySelector('kd-related-products');
            if (!section) throw new Error('Recommendations section missing');
            this.innerHTML = section.innerHTML;
            this.dataset.state = this.querySelector('.kd-card') ? 'loaded' : 'empty';
          })
          .catch(() => { this.dataset.state = 'error'; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
